/* BUKI: shared behaviour fixes for both themes (loaded from bk-head). */
(function () {
  /* 1. Collection grids: 3 or 4 across on desktop, picked by the size of the collection so rows come out even.
        The end-of-grid tile fills whatever is left in the last row, so the grid always ends square.
        Tablets show 3 across, phones 2. */
  function pick(n) { if (n % 4 === 0) return 4; if (n % 3 === 0) return 3; return n >= 12 ? 4 : 3; }
  function layout() {
    [].forEach.call(document.querySelectorAll('.bk-col [data-bk-grid]'), function (g) {
      var root = g.closest('.bk-col');
      var more = root.querySelector('[data-bk-more]');
      var cards = g.querySelectorAll(':scope > .bk-card').length;
      var promos = g.querySelectorAll(':scope > .bk-col__promo').length;
      var countEl = root.querySelector('.bk-col__count');
      var total = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
      var n = more ? Math.max(total, cards) : cards;
      var w = window.innerWidth;
      var c = w >= 990 ? pick(n) : (w >= 750 ? 3 : 2);
      g.style.setProperty('grid-template-columns', 'repeat(' + c + ',minmax(0,1fr))', 'important');
      g.style.setProperty('max-width', 'none', 'important');
      g.setAttribute('data-bk-cols', c);
      var fill = g.querySelector(':scope > [data-bk-fill]');
      if (fill) {
        var r = (cards + promos) % c;
        if (!more && r) { fill.style.setProperty('display', 'flex', 'important'); fill.style.setProperty('grid-column', 'span ' + (c - r), 'important'); }
        else { fill.style.setProperty('display', 'none', 'important'); }
      }
    });
  }

  /* 2. Collection pages load the next set of products automatically as you scroll (the button stays as a fallback). */
  function near(el) { var r = el.getBoundingClientRect(); return r.top < window.innerHeight + 700; }
  function autoload() {
    [].forEach.call(document.querySelectorAll('.bk-col [data-bk-more]'), function (btn) {
      if (btn.getAttribute('data-bk-auto')) return;
      btn.setAttribute('data-bk-auto', '1');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && /load more/i.test(btn.textContent)) btn.click(); });
      }, { rootMargin: '0px 0px 700px 0px' });
      io.observe(btn);
      var busy = 0;
      window.addEventListener('scroll', function () {
        if (busy) return; busy = 1;
        setTimeout(function () { busy = 0; if (document.body.contains(btn) && /load more/i.test(btn.textContent) && near(btn)) btn.click(); }, 200);
      }, { passive: true });
      var grid = btn.closest('.bk-col').querySelector('[data-bk-grid]');
      new MutationObserver(function () {
        setTimeout(function () { if (document.body.contains(btn) && /load more/i.test(btn.textContent) && near(btn)) btn.click(); }, 300);
      }).observe(grid, { childList: true });
    });
  }

  /* 3. Collection titles stay on one line: long titles step down in size instead of being cut off. */
  function fitTitles() {
    [].forEach.call(document.querySelectorAll('.bk-col__h'), function (h) {
      h.style.removeProperty('font-size');
      h.style.setProperty('white-space', 'nowrap', 'important');
      h.style.setProperty('overflow', 'visible', 'important');
      h.style.setProperty('text-overflow', 'clip', 'important');
      h.style.setProperty('max-width', '100%', 'important');
      var box = h.parentElement.clientWidth, fs = parseFloat(getComputedStyle(h).fontSize), min = Math.max(22, fs * 0.5);
      while (h.scrollWidth > box + 1 && fs > min) { fs -= 1; h.style.setProperty('font-size', fs + 'px', 'important'); }
      if (h.scrollWidth > box + 1) h.style.setProperty('white-space', 'normal', 'important');
    });
  }

  /* 4. Empty collections (nothing in stock yet) get a helpful message instead of the "no filter matches" one. */
  function emptyState() {
    [].forEach.call(document.querySelectorAll('.bk-col .bk-col__empty'), function (e) {
      if (e.getAttribute('data-bk-done') || document.querySelector('.bk-col__active')) return;
      e.setAttribute('data-bk-done', '1');
      var h = e.querySelector('h2'); if (h) h.textContent = 'New pieces are on the way';
      var a = e.querySelector('a'); if (a) { a.textContent = 'Shop bestsellers'; a.setAttribute('href', '/collections/mens-bestsellers'); }
    });
  }

  function run() { layout(); autoload(); fitTitles(); emptyState(); }
  var t; function later() { clearTimeout(t); t = setTimeout(run, 120); }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitles);
  document.addEventListener('DOMContentLoaded', function () {
    [].forEach.call(document.querySelectorAll('.bk-col [data-bk-grid]'), function (g) {
      new MutationObserver(later).observe(g, { childList: true });
    });
    var c = document.querySelector('.bk-col'); if (c) new MutationObserver(later).observe(c, { childList: true, subtree: true, attributes: false });
  });
})();
